import { MODULE } from "@/config/modules";
import { DidNotPurchaseReason } from "@/models/company-did-not-purchase-reason";
import { Tier } from "./tier";


export interface ICompanyFiltersAccountStatus{
	isNotDemo: boolean,
	activeDemo: boolean,
	activeService: boolean,
	permanentService:boolean,
	expiredDemo: boolean,
	expiredService: boolean
	hasPermanentAccount: boolean,
	hasSubscription: boolean,
	isDemo: boolean,
	isExpired: boolean,
	isNotExpired: boolean
	hasBoughtSPAtLeastOnce: boolean,
	hasNeverBoughtSP:boolean
}


export class CompanyFilters {
	accountStatus:ICompanyFiltersAccountStatus={
		isNotDemo: false,
		activeDemo: false,
		activeService: false,
		permanentService: false,
		expiredDemo: false,
		expiredService: false,
		hasPermanentAccount: false,
		hasSubscription: false,
		isDemo: false,
		isExpired: false,
		isNotExpired: false,
		hasBoughtSPAtLeastOnce: false,
		hasNeverBoughtSP: false
	};
	employeeAccounts:boolean | null = null;
	modules:MODULE[] = [];
	searchQuery:string = "";
	tiers:Tier[] = [];
	accountCreatedByNone:boolean = false;
	accountCreatedByWinfaktOnline:boolean = false;
	accountCreatedByWinfaktClassic:boolean = false;
	accountCreatedByFacturatieBe:boolean = false;
	createdBeforeDate:Date | null = null;
	createdAfterDate:Date | null = null;
	didNotPurchaseReasons:DidNotPurchaseReason[] =[];
	vars:{
		visitedPricingPage:boolean | null;
	}={
		visitedPricingPage: null
	}
	dbId:number | null = null;

	discoveredUsFrom:{
		google:boolean,
		facebook:boolean,
		instagram:boolean,
		otherSocialMedia:boolean,
		friendOracquaintance:boolean,
		myAccountant:boolean,
		other:boolean,
		none:boolean,
	}={
		google: false,
		facebook: false,
		instagram: false,
		otherSocialMedia: false,
		friendOracquaintance: false,
		myAccountant: false,
		other: false,
		none: false,
	};

	// eslint-disable-next-line max-lines-per-function
	public constructor(data?:any) {
		if (!data) return;
		this.accountStatus.isNotDemo = data.accountStatus.isNotDemo;
		this.accountStatus.activeDemo = data.accountStatus.activeDemo;
		this.accountStatus.activeService = data.accountStatus.activeService;
		this.accountStatus.expiredDemo = data.accountStatus.expiredDemo;
		this.accountStatus.expiredService = data.accountStatus.expiredService;
		this.accountStatus.hasPermanentAccount = data.accountStatus.hasPermanentAccount;
		this.accountStatus.hasSubscription = data.accountStatus.hasSubscription;
		this.accountStatus.isDemo = data.accountStatus.isDemo;
		this.accountStatus.isExpired = data.accountStatus.isExpired;
		this.accountStatus.isNotExpired = data.accountStatus.isNotExpired;
		this.accountStatus.permanentService = data.accountStatus.permanentService;
		this.accountStatus.hasBoughtSPAtLeastOnce = data.accountStatus.hasBoughtSPAtLeastOnce;
		this.accountStatus.hasNeverBoughtSP = data.accountStatus.hasNeverBoughtSP;

		this.employeeAccounts = data.employeeAccounts;
		this.modules = data.modules || [];
		this.searchQuery = data.searchQuery;
		this.tiers = data.tiers || [];
		this.accountCreatedByNone = data.accountCreatedByNone;
		this.accountCreatedByWinfaktOnline = data.accountCreatedByWinfaktOnline;
		this.accountCreatedByWinfaktClassic = data.accountCreatedByWinfaktClassic;
		this.accountCreatedByFacturatieBe = data.accountCreatedByFacturatieBe;
		this.createdBeforeDate = this.decodeDate(data.createdBefore);
		this.createdAfterDate = this.decodeDate(data.createdAfter);
		this.didNotPurchaseReasons = data.didNotPurchaseReasons || [];

		if (data.discoveredUsFrom){
			this.discoveredUsFrom.google = data.discoveredUsFrom.google;
			this.discoveredUsFrom.facebook = data.discoveredUsFrom.facebook;
			this.discoveredUsFrom.instagram = data.discoveredUsFrom.instagram;
			this.discoveredUsFrom.otherSocialMedia = data.discoveredUsFrom.otherSocialMedia;
			this.discoveredUsFrom.friendOracquaintance = data.discoveredUsFrom.friendOracquaintance;
			this.discoveredUsFrom.myAccountant = data.discoveredUsFrom.myAccountant;
			this.discoveredUsFrom.other = data.discoveredUsFrom.other;
			this.discoveredUsFrom.none = data.discoveredUsFrom.none;
		}

		if (data.vars){
			this.vars.visitedPricingPage = data.vars.visitedPricingPage;
		}

		this.dbId = data.dbId;

	}

	// eslint-disable-next-line max-lines-per-function
	public getJSON(){
		return {
			accountStatus: {
				IsNotDemo: this.accountStatus.isNotDemo,
				activeDemo: this.accountStatus.activeDemo,
				activeService: this.accountStatus.activeService,
				permanentService: this.accountStatus.permanentService,
				expiredDemo: this.accountStatus.expiredDemo,
				expiredService: this.accountStatus.expiredService,
				hasPermanentAccount: this.accountStatus.hasPermanentAccount,
				hasSubscription: this.accountStatus.hasSubscription,
				isDemo: this.accountStatus.isDemo,
				isExpired: this.accountStatus.isExpired,
				isNotExpired: this.accountStatus.isNotExpired,
				hasBoughtSPAtLeastOnce: this.accountStatus.hasBoughtSPAtLeastOnce,
				hasNeverBoughtSP: this.accountStatus.hasNeverBoughtSP
			},
			employeeAccounts: this.employeeAccounts,
			modules: [...this.modules],
			searchQuery: this.searchQuery,
			tiers: [...this.tiers],
			accountCreatedByNone: this.accountCreatedByNone,
			accountCreatedByWinfaktOnline: this.accountCreatedByWinfaktOnline,
			accountCreatedByWinfaktClassic: this.accountCreatedByWinfaktClassic,
			accountCreatedByFacturatieBe: this.accountCreatedByFacturatieBe,
			createdBefore: this.encodeDate(this.createdBeforeDate),
			createdAfter: this.encodeDate(this.createdAfterDate),
			didNotPurchaseReasons: [...this.didNotPurchaseReasons],
			discoveredUsFrom: {
				google: this.discoveredUsFrom.google,
				facebook: this.discoveredUsFrom.facebook,
				instagram: this.discoveredUsFrom.instagram,
				otherSocialMedia: this.discoveredUsFrom.otherSocialMedia,
				friendOracquaintance: this.discoveredUsFrom.friendOracquaintance,
				myAccountant: this.discoveredUsFrom.myAccountant,
				other: this.discoveredUsFrom.other,
				none: this.discoveredUsFrom.none,
			},
			vars: {
				visitedPricingPage: this.vars.visitedPricingPage
			},
			dbId: this.dbId
		};
	}

	private encodeDate(date:Date | null):string | null{
		if (!date) return null;
		let newDate = new Date(date);
		let timezoneOffset = newDate.getTimezoneOffset();
		newDate.setMinutes(newDate.getMinutes() - timezoneOffset);
		return newDate.toJSON();
	}

	private decodeDate(d:string | null):Date | null {
		if (!d) return null;
		let date = new Date(d);
		let timezoneOffset = date.getTimezoneOffset();
		date.setMinutes(date.getMinutes() + timezoneOffset);
		return date;
	}
}